import { render, staticRenderFns } from "./finance-data-panel-b.vue?vue&type=template&id=751a97a9&scoped=true&"
import script from "./finance-data-panel-b.vue?vue&type=script&lang=js&"
export * from "./finance-data-panel-b.vue?vue&type=script&lang=js&"
import style0 from "./finance-data-panel-b.vue?vue&type=style&index=0&id=751a97a9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "751a97a9",
  null
  
)

export default component.exports